module.exports = __webpack_public_path__ + "img/box_colors.c1ddcdbb.webp";